// constants.js

import { apiClient } from '../../services/api/baseApi';

export const PICKLISTS_API = '/salesforce/accounts/picklists';

/**
 * Fetch picklist values dynamically
 * @returns {Promise<{ typeOptions: string[], regionOptions: string[] }>}
 */
export async function fetchPicklists() {
  const res = await apiClient.get(PICKLISTS_API);
  const json = res.data;

  const typeOptions = json?.data?.Type?.values
    ?.filter(v => v.active)
    ?.map(v => v.value) || [];

  const regionOptions = json?.data?.GMB_Region__c?.values
    ?.filter(v => v.active)
    ?.map(v => v.value) || [];

  return { typeOptions, regionOptions };
}
